import { Phone } from "lucide-react";
import { ScheduleCallButton } from "./schedule-call-button";
import { Button } from "./ui/button";
import Link from "next/link";

export default function Contact() {
  return (
    <section className="relative overflow-hidden mb-48 mt-20">
      {/* Background Image */}
      <div
        className="relative bg-cover bg-center"
        style={{
          backgroundImage: "url('/images/copy.jpg')",
        }}
      >
        {/* Dark Overlay - Updated to match reference color */}
        <div className="absolute inset-0 bg-[#0F2929] h-full" />

        <div className="relative z-10 max-w-[80%] mx-auto px-4 sm:px-6 lg:px-8 py-10 flex items-center">
          <div className="grid lg:grid-cols-2 gap-8 items-center w-full">
            {/* Left Content */}
            <div className="max-w-3xl">
              {/* Badge - Matching reference style */}
              <span className="inline-block px-3 py-1 bg-[#0092B8]/20 text-[#0092B8] text-xs uppercase font-semibold tracking-wide mb-4">
                GET IN TOUCH
              </span>

              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight mb-4">
                Let's Build Your Dream Home.
              </h2>

              <p className="text-white/90 text-sm md:text-base leading-relaxed max-w-2xl">
                Whether it's a new build, a remodel, or just an idea — we're
                here to help bring it to life.
              </p>

              <p className="text-white/90 text-sm md:text-base leading-relaxed mt-2">
                Let's talk and explore how Hexad can make it happen.
              </p>
            </div>

            {/* Right CTA - Updated button styling matching reference */}
            <div className="flex lg:justify-end">
              <Link href="/contact">
                <Button
                  size="default"
                  className="bg-[#0092B8] hover:bg-[#007a9a] text-white font-bold px-6 py-2 rounded-full text-sm uppercase tracking-wide transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl"
                >
                  Enquire Now
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
